import { modeIconMap } from 'wanderu-assets';
import { CONSTANTS as LIVECHECK_CONSTANTS } from 'wanderu-ducks-live-check';

import multiIcon from 'wanderu-assets/images/multimodal-grey.svg';

const {
    ERROR,
    NOT_FOUND,
    SUCCESS_NO_CHANGE,
    SUCCESS_PRICE_DOWN,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
} = LIVECHECK_CONSTANTS;

const ARRIVAL_TYPE = 'arrival';
const DEPART_DIRECTION = 'depart';
const DEPARTURE_TYPE = 'departure';
const IN_PROGRESS = 'in_progress';
const MIN_LIVE_CHECK_LOAD_TIME = 3000;
const NOT_STARTED = 'not_started';
const RETURN_DIRECTION = 'return';
const TRAVEL_MODE_ICON_MAP = {
    ...modeIconMap,
    multi: multiIcon,
};
const TRAVEL_MODE_TRANSLATION_MAP = {
    auto: 'auto',
    bus: 'bus',
    ferry: 'ferry',
    flight: 'flights',
    multi: 'mixed-modes',
    shuttle: 'shuttle',
    train: 'train',
};
const RENTAL_CARS_AD_INDEX = 2;

const ALTERNATIVE_SEARCH_DAYS = 3;

export {
    ALTERNATIVE_SEARCH_DAYS,
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
    DEPART_DIRECTION,
    ERROR,
    IN_PROGRESS,
    MIN_LIVE_CHECK_LOAD_TIME,
    NOT_FOUND,
    NOT_STARTED,
    RENTAL_CARS_AD_INDEX,
    RETURN_DIRECTION,

    SUCCESS_NO_CHANGE,
    SUCCESS_PRICE_DOWN,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
    TRAVEL_MODE_ICON_MAP,

    TRAVEL_MODE_TRANSLATION_MAP,
};
